import { createApp } from "vue";

import App from "./tpls/index.vue";
// import 'virtual:svg-icons-register';
createApp(App).mount("#app");
